







import { get } from 'vuex-pathify';
import Vue from 'vue';

export default Vue.extend({
  name: 'Home',
  components: {},
  data: () => ({
    items: [
      {
        title: 'Connected Apps',
        icon: 'mdi-account-box-multiple-outline',
        to: { name: 'settings-integrations' }
      },
      { title: 'Settings', icon: 'mdi-calendar' },
      { title: 'Event', icon: 'mdi-gavel' }
    ]
  }),
  computed: {
    miniCompanyImage: get('app/miniCompanyImage')
  }
});
